var team = {};
module['exports'] = team;
team.suffix = require("./suffix");
team.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/team/index.js
// module id = 1404
// module chunks = 0